import { useLocation, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getToken } from "../utils";
import { changeLoginModalDisplayAciton } from "../actions/authActions";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();

  const isAuthenticated = !!getToken();

  if (!isAuthenticated) {
    // Show login modal
    dispatch(changeLoginModalDisplayAciton("block"));
    sessionStorage.setItem("postLoginRedirect", location.pathname);

    return <Navigate to={location.state?.from || "/"} replace />;
  }

  return children;
}
